import { Component, Inject, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { Request } from '../request.model';
import { takeUntil } from 'rxjs/operators';
import { RequestService } from '@fuse/services/request/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyService } from '@fuse/services/company.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector: 'request-form-dialog',
    templateUrl: './request-form.component.html',
    styleUrls: ['./request-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class RequestFormDialogComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any>;
    action: string;
    request: Request;
    requestTypes: any;
    company: any;
    requestForm: FormGroup;
    dialogTitle: string;
    cities: any[];
    enabledCities: any[];
    lang = 'sr';
    selectedType: any;

    /**
     * Constructor
     *
     * @param {MatDialogRef<RequestFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<RequestFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _requestService: RequestService,
        private _formBuilder: FormBuilder,
        private _matSnackBar: MatSnackBar,
        private _companyService: CompanyService,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService
    ) {
        this._unsubscribeAll = new Subject();

        // Set the defaults
        this.action = _data.action;

        this.dialogTitle = 'New request';
        this.request = new Request({});


        this.requestForm = this.createRequestForm();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '23');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    // convenience getter for easy access to form fields
    get f(): any { return this.requestForm.controls; }

    checkTypeChange(type): void {
        this.selectedType = type.triggerValue;
    }

    /**
     * Create city form
     *
     * @returns {FormGroup}
     */
    createRequestForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.request.id],
            type: [this.request.type],
            comment: [this.request.comment]
        });
    }

    checkServerError(fieldName): any {
        return this.requestForm.get(fieldName).errors ? this.requestForm.get(fieldName).errors.serverError ?
            this.requestForm.get(fieldName).errors.serverError : this._translate.instant('This field is required!') : false;
    }

    createRequest(requestForm): void {
        this._requestService.createRequest(requestForm.getRawValue().type.id, requestForm.getRawValue().comment, this.company.id)
            .then(x => {

                this.matDialogRef.close(['save', requestForm]);

                // Show the success message
                this._matSnackBar.open(this._translate.instant('Request') + ' ' + requestForm.getRawValue().type.name + this._translate.instant(' created successfully.'), '', {
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    duration: 2000
                });
            })
            .catch(err => Promise.reject(err))
            .then(x => { }, err => {
                const formControl = this.requestForm.get('request');
                console.log(err);
                if (formControl) {
                    formControl.setErrors({
                        serverError: err.error.message
                    });
                }

                console.log('Error:', err.statusText);
            });
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {
        this._companyService.getActiveCompany()
            .then(response => {
                this.company = response;
            })
            .catch(err => Promise.reject(err))
            .then(() => {
                this._requestService.getAllRequestTypes(this.company.id)
                    .then(response => {
                        this.requestTypes = response.data;
                    });
            }, err => {
            });

        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });

        this.getTranslations();

    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
